import { JoonUIColor, SPACING, Typography } from "@joonapp/web-shared"
import { useTranslation } from "react-i18next"

import CatchUpCardContent from "./CatchUpCardContent"
import CatchUpCardStatusOverlay from "./CatchUpCardStatusOverlay"
import CatchUpCompleteContent from "./CatchUpCompleteContent"
import CatchUpCompleteUserSelectHeader from "./CatchupCompleteUserSelectHeader"
import CatchUpTabBar from "./CatchUpTabBar"
import CatchUpTabBarReviewButtons from "./CatchUpTabBarReviewButtons"
import CatchUpUserSelectHeader from "./CatchUpUserSelectHeader"
import { useCatchUpStore } from "./useCatchUpStore"
import { CloseButton } from "../../components/closeButton/CloseButton"
import SlideUpModal from "../../components/slideUpModal/SlideUpModal"
import useMobile from "../../hooks/useMobile"
import { useQuestBoardQuery } from "../../networking/queries"

const CatchUp = () => {
  const { isOpen, onClose, showCard, selectedQuest } = useCatchUpStore(
    (state) => ({
      isOpen: state.isOpen,
      onClose: state.onClose,
      showCard: state.showCard,
      selectedQuest: state.selectedQuest,
    })
  )
  const isReviewing = useCatchUpStore((state) => state.isReviewing)
  const isMobile = useMobile()
  const { t } = useTranslation()
  useQuestBoardQuery() // Added query here to get around rerendering quest data issue

  return (
    <SlideUpModal
      isOpen={isOpen}
      onClose={onClose}
      showCard={showCard}
      size="default"
      backgroundType={isMobile ? "solid" : "overlay"}
    >
      <div className="flex flex-col flex-1">
        <CloseButton onClick={onClose} />
        <Typography
          variant="bodySmallBold"
          style={{
            padding: `${SPACING.space3} ${SPACING.space4}`,
            borderBottom: `1px solid ${JoonUIColor.border.default}`,
          }}
        >
          {isReviewing ? t("CATCHUP_VERIFY_TITLE") : t("CATCHUP_REVIEW_TITLE")}
        </Typography>
        <div className="px-3 py-3 border-b border-borderPrimary">
          {isReviewing ? (
            <CatchUpUserSelectHeader />
          ) : (
            <CatchUpCompleteUserSelectHeader />
          )}
        </div>
        {isReviewing ? <CatchUpCardContent /> : <CatchUpCompleteContent />}
      </div>

      {isReviewing && selectedQuest && (
        <>
          <CatchUpCardStatusOverlay />
          <CatchUpTabBar>
            <CatchUpTabBarReviewButtons />
          </CatchUpTabBar>
        </>
      )}
    </SlideUpModal>
  )
}

export default CatchUp
